import { delay, put, takeEvery } from 'redux-saga/effects';
import {
  addToast,
  removeToast,
  type ToastStateType,
} from '../slices/toast-slice';
import type { PayloadAction } from '@reduxjs/toolkit';

const TOAST_AUTO_DISMISS_DELAY = 5000;

function* autoRemoveToastSaga(
  action: PayloadAction<Omit<ToastStateType['items'][0], 'id'>>
) {
  const id = Date.now().toString();

  yield delay(TOAST_AUTO_DISMISS_DELAY);
  yield put(removeToast(id));
}

export function* toastSaga() {
  yield takeEvery(addToast.type, autoRemoveToastSaga);
}
